import request from '@/utils/request'

export function getList(rank_type,page) {
    return request({
        url: '/web/school_rank/get_list',
        method: 'post',
        data: {
            rank_type: rank_type,
            page: page
        }
    })
}

export function getCategoryList() {
    return request({
        url: '/syjy/special_rank/getCategory',
        method: 'post',
        data: {}
    })
}

export function getEvaluationList(spec_cate_id) {
    return request({
        url: '/web/special_rank/getEvaluationList',
        method: 'post',
        data: {
            spec_cate_id: spec_cate_id
        }
    })
}